const HIGHLIGHT_COLOR = '#fff4e6'

const getHighligtedIndexes = (textWords: string[], queryWords: string[]) =>
  textWords.reduce((foundWordsIndexes: number[], item, index) => {
    const found = queryWords.find((word) => item.toLowerCase().includes(word))
    if (found) foundWordsIndexes.push(index)
    return foundWordsIndexes
  }, [])

const highlightText = (queryWords?: string[], text?: string) => {
  if ((!queryWords || !queryWords.length) && text) return text
  if (!queryWords || !queryWords.length || !text) return
  const textWords = text.split(' ')

  const highlightIndexes = getHighligtedIndexes(textWords, queryWords)

  let isHighlighting = false

  const textWithHighlights = textWords
    .reduce((wordsArray: string[], textWord, index) => {
      const highlightedWords = []
      const isFound = highlightIndexes.includes(index)

      if (!isHighlighting && isFound) {
        highlightedWords.push(`<span style="background-color: ${HIGHLIGHT_COLOR};">`)
        isHighlighting = true
      } else if (isHighlighting && !isFound) {
        highlightedWords.push('</span>')
        isHighlighting = false
      }

      highlightedWords.push(textWord)
      if (isHighlighting && index === textWords.length - 1) {
        highlightedWords.push('</span>')
        isHighlighting = false
      }
      return [...wordsArray, ...highlightedWords]
    }, [])
    .join(' ')

  return <span dangerouslySetInnerHTML={{ __html: textWithHighlights }} />
}

export { highlightText }
